import React from 'react';

const Footer = () => {
  return (
    <footer className="footer" style={{ position: 'fixed', bottom: -15, left: 0, width: '100%', zIndex: 1000 }}>
      <p className="text-center">© {new Date().getFullYear()} Nuveen, LLC. All rights reserved.</p>
    </footer>
  );
}

export default Footer;